import { makeStyles } from '@material-ui/core'
import { getObjectLabels } from '@paintscout/util/builder'
import React, { useState } from 'react'
import Button from '../components/Button'
import { useClientOptions } from '../providers/ClientOptionsProvider'
import type { DialogProps } from '../components/Dialog'
import Dialog, { DialogActions, DialogContent, DialogTitle } from '../components/Dialog'
import Grid from '../components/Grid'
import SelectableChipLarge from '../components/SelectableChip/SelectableChipLarge'
import Typography from '../components/Typography'

// Copied from salesforce-provider types, keep in sync
export type SalesforceOpportunity = {
  Id: string
  Name: string
  Amount: number
  StageName: string
}

export interface SelectOpportunityDialogProps extends DialogProps {
  opportunities: SalesforceOpportunity[]
  onConfirm: (opportuntityId: string) => void
  onCancel: (event: React.MouseEvent<HTMLElement>) => void
}

const useStyles = makeStyles((_theme) => ({
  opportunities: {
    padding: '2.5px'
  }
}))

function SelectOpportunityDialog({ onCancel, onConfirm, opportunities, ...otherProps }: SelectOpportunityDialogProps) {
  const { options } = useClientOptions()
  const objectLabels = getObjectLabels({ options })
  const [selectedOpportuntityId, setSelectedOpportunityId] = useState(null)
  const classes = useStyles(otherProps)
  async function handleConfirm(_ev: any) {
    onConfirm(selectedOpportuntityId)
  }

  return (
    <Dialog open={true} onClose={onCancel}>
      <DialogTitle>Choose Opportunity</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} justifyContent="space-between" direction="column">
          <Grid item xs={12}>
            <Typography variant={'body1'}>
              We've identified multiple opportunities associated with this contact. Please select the opportunity you
              wish to link to this {objectLabels.quote.value.toLowerCase()}.
            </Typography>
          </Grid>
          <Grid item xs={12} style={{ maxWidth: '700px' }}>
            <Grid container justifyContent="space-between" direction="column">
              {opportunities.map((opportunity) => {
                const sublabel = [opportunity.Amount ? `$${opportunity.Amount}` : '', opportunity.StageName ?? '']
                  .filter(Boolean)
                  .join(' - ')
                return (
                  <Grid item className={classes.opportunities} key={opportunity.Id}>
                    <SelectableChipLarge
                      label={`${opportunity.Name}`}
                      sublabel={sublabel}
                      selected={opportunity.Id === selectedOpportuntityId}
                      onClick={() => {
                        setSelectedOpportunityId(opportunity.Id)
                      }}
                    />
                  </Grid>
                )
              })}
              <Grid item className={classes.opportunities}>
                <SelectableChipLarge
                  label={`No Opportunity`}
                  sublabel={``}
                  selected={selectedOpportuntityId === 'none'}
                  onClick={() => {
                    setSelectedOpportunityId('none')
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions
        leftButton={
          <Button onClick={onCancel} variant="textNoPadding">
            Cancel
          </Button>
        }
      >
        <Button disabled={!selectedOpportuntityId} onClick={handleConfirm} variant={'contained'}>
          Done
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default SelectOpportunityDialog
